<template>
  <div class="barra-lateral-esquerdo">

    <figure @click="deslogar" class="figure-image">
      <div v-if="getDeslog" class="backGroundOrangeRed">
        <img src="/imgs/icons/power-white.svg" class="img" />
        <figcaption>Deslogado</figcaption>
      </div>
      <div v-else class="backgroundGreen">
        <img src="/imgs/icons/power-white.svg" class="img" />
        <figcaption>Logado</figcaption>
      </div>
    </figure>

    <figure @click="operatorRealtime()" class="figure-image">
      <div :class="{ 'bg-adv': getOperatorRealtime }">
        <img src="/imgs/icons/realtime-icon.svg" class="img" />
        <figcaption>Realtime</figcaption>
      </div>
    </figure>

    <figure @click="contacts()" class="figure-image">
      <div :class="{ 'bg-adv': getContacts }">
        <img src="/imgs/icons/address-book.svg" class="img" />
        <figcaption>Contatos</figcaption>
      </div>
    </figure>

    <figure v-if="telefone" class="figure-image">
      <div
        v-if="getChannel() != ''"
        @click="hangup"
        class="backGroundOrangeRed"
      >
        <img src="/imgs/icons/telephone-forward-white.svg" class="img" alt="" />
        <figcaption>Desligar</figcaption>
      </div>
      <div v-else @click="discar">
        <img src="/imgs/icons/telephone-forward-white.svg" class="img" alt="" />
        <figcaption>Discar</figcaption>
      </div>
    </figure>

    <figure v-if="telefone" @click="pause" class="figure-image">
			<div v-if="getPause" :class="['backGroundOrange', { 'blink-red': isBlinking }]">
				<img src="/imgs/icons/pause-white.svg" class='img'>
				<figcaption>{{ time_pause_format }} <br> Pausado</figcaption>
			</div>
			<div v-else>
				<img src="/imgs/icons/pause-white.svg" class='img'>
				<figcaption>Pausar</figcaption>
			</div>
		</figure>

    <figure v-if="telefone" @click="mute" class="figure-image">
      <div v-if="getMute" class="backGroundOrange">
        <img src="/imgs/icons/mute-white.svg" class="img" alt="" />
        <figcaption>Mudo</figcaption>
      </div>
      <div v-else>
        <img src="/imgs/icons/mute-white.svg" class="img" alt="" />
        <figcaption>Mute</figcaption>
      </div>
    </figure>

    <figure @click="agendamento" class="figure-image" style="display: none">
      <div class="">
        <img src="/imgs/icons/calendar-date-white.svg" class="img" />
        <figcaption>Agendamento</figcaption>
      </div>
    </figure>

    <div hidden>{{ loadUserData }}</div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import clientData from "../../store/modules/spearhead";
const parsedTelefone = process.env.MIX_TELEFONE === "true";
const connection = parsedTelefone
  ? io.connect(`${location.protocol}//${location.hostname}:3006/`)
  : { on: function () {}, emit: function () {} };

export default {
  data() {
    return {
      interval_pause: "",
      time_pause: "",
      time_pause_format: "00:00:00",
      debugDisc: false,
      total_in_queue: "",
      userQueues: [],
      logando: false,
      queuePause: false,
      telefone: parsedTelefone,
      isBlinking: false,
			redFlag: false,
      ramal: user.getExtension(),
      hangupObj: {
        dados: [],
        uniqueid: "",
      },
    };
  },
  computed: {
    ...mapGetters([
      "getDeslog",
      "getModalPause",
      "getMessages",
      "getOccurrences",
      "getShowHistory",
      "getCnpj",
      "getPause",
      "getMute",
      "getQueues",
      "getExtension",
      "getId",
      "getChannel",
      "getChamada",
      "allClients",
      "getShowSpearhead",
      "getProtocol",
      "getCallTime",
      "getPauseTime",
      "oneClient",
      "getShowBarRight",
      "getTotalMyQueue",
      "getTotalInQueue",
      "getContacts",
      "getCalendar",
      "getOperatorRealtime",
      "getShowBillingCampaign",
      "getStartCountdown",
      "getShowCommercialCampaign",
      "getShowImplantacaoCampaign",
      "getMotivoPause",
      "getModalCall"
    ]),
    loadUserData: function () {
      this.setExtension(user.getId());
      this.setQueues(user.getQueue());
      this.setId(user.getId());
    },
  },
  watch: {
    getPauseTime: function () {
      this.validateTimePause();
    },
    time_pause: function () {
      this.time_pause_format = moment
        .utc(this.time_pause * 1000)
        .format("HH:mm:ss");
    },
  },
  created() {
    this.setMessage();
    if(user.getQueue().length){
      user.getQueue().map(el => this.userQueues.push({queue: el, logged: false, paused: false}))
    }
    if (this.telefone) return;

    this.startOrOut();
  },
  methods: {
    ...mapActions([
      "selectPause",
      "sendPauseApi",
      "sendOperatorPauseApi",
      "setOccurrences",
      "setShowHistory",
      "setModalPause",
      "setModalSchedule",
      "settModalCall",
      "setMessage",
      "fetchOcurrences",
      "fetchPauses",
      "comeBack",
      "setDeslog",
      "startOrOut",
      "setMute",
      "setExtension",
      "setQueues",
      "setId",
      "getRealTime",
      "sendUnpause",
      "sendOperatorUnpause",
      "setChannel",
      "fetchClients",
      "fetchProtocol",
      "setShowSpearhead",
      "chooseClient",
      "chooseClientCnpj",
      "clearAllClients",
      "setCallTime",
      "setPauseTime",
      "saveProduct",
      "clearClient",
      "saveClient",
      "setShowBarRight",
      "checkTotalQUeues",
      "totalMyQueue",
      "setContacts",
      "chooseClientPhone",
      "setShowBillingCampaign",
      "setShowCommercialCampaign",
      "setShowImplantacaoCampaign",
      "setStartCampaign",
      "setDelDataConnectLine",
      "setCallData",
      'fetchStoreQueues',
      'setOperatorRealtime'
    ]),
    ...mapMutations(["setClient", "setMotivoPause"]),
    validateTimePause() {
			const audio = new Audio('/sounds/blinking-bell.mp3');

			this.time_pause = (this.getPauseTime != 'null') ? this.getPauseTime : 0;
			if(this.getPauseTime != 'null') {
			// Incrementa o contador a cada segundo
				this.interval_pause = setInterval(() => {
					this.time_pause++;
					if(this.break === "almoço"){
							if (this.time_pause === 5700) {
							audio.play();
							this.startBlinking();
							this.redFlag = true;

							// Inicia um novo intervalo para tocar o áudio a cada 15 segundos
							this.audio_interval = setInterval(() => {
								if(this.redFlag){
									audio.play();
								}						
							}, 10000);
						}
					}

          if(this.break === "café"){
							if (this.time_pause === 900) {
							audio.play();
							this.startBlinking();
							this.redFlag = true;

							// Inicia um novo intervalo para tocar o áudio a cada 15 segundos
							this.audio_interval = setInterval(() => {
								if(this.redFlag){
									audio.play();
								}						
							}, 10000);
						}
					}

          if(this.break === "toilet"){
							if (this.time_pause === 600) {
							audio.play();
							this.startBlinking();
							this.redFlag = true;

							// Inicia um novo intervalo para tocar o áudio a cada 15 segundos
							this.audio_interval = setInterval(() => {
								if(this.redFlag){
									audio.play();
								}						
							}, 10000);
						}
					}
				}, 1000);
			}else {
				clearInterval(this.interval_pause);
			}
		},
		startBlinking() {
			this.isBlinking = true;
		},
    historicol() {
      if (!this.getDeslog && !this.getShowHistory) {
        this.setShowHistory();
        this.fetchOcurrences(this.getCnpj);
      }
    },
    discar() {
      if(!this.getModalCall){
        if(user.getProfile() == 2){
          if(!this.getDeslog) this.settModalCall();
        } else {
          this.settModalCall();
        }
      }
    },
    getTime() {
      var d = new Date();
      return d.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
    },
    pause() {
      if(this.getPause == true) {
        this.isBlinking = false;
				this.redFlag = false;
        this.userQueues.forEach(el => {
          if(el.paused){
            // el.paused = false
            connection.emit('QueueUnPause', {
              extension: user.getExtension(),
              queue: el.queue
            });
          }
        })
			} 
			else {
				if(this.getDeslog == false) {
					this.setModalPause();
					this.fetchPauses();
				}
			}
		},
    agendamento() {
      this.setModalSchedule();
    },
    deslogar() {
      if (!this.telefone) return;
      var data = {
        queues: user.getQueue(),
        extension: user.getExtension(),
      };
      if (this.getDeslog) {
        //EVITA DOIS QueueAdd SE CLICAR DE NOVO ENQUANTO AS FILAS AGENDADAS SÃO CONSULTADAS
        if (this.logando) return;
        this.logando = true;

        //APLICA ALTERAÇÃO DE FILAS AGENDADA (SE HOUVER) ANTES DE ENTRAR NAS FILAS
        this.aplicarFilasAgendadas().then(() => {
          this.logando = false;
          data.queues = user.getQueue();
          connection.emit("QueueAdd", data, (response) => {
            response.forEach(result => {
              if (result.status === 'success') {
                  let find = this.userQueues.find(el => el.queue === result.queue)
                  if(find){
                    find.logged = true
                  }
              } else if (result.status === 'error') {
                  console.error(`Erro: ${result.message}`);
                  console.error(`Detalhes: ${result.error}`);
              }
            });
          });
        });
      } else {
        if(user.getProfile() == 2){
          if(!this.getMessages) this.setMessage()
        }

        connection.emit("QueueRemove", data, (response) => {
          response.forEach(result => {
            if (result.status === 'success') {
                let find = this.userQueues.find(el => el.queue === result.queue)
                if(find){
                  find.logged = false
                }
            } else if (result.status === 'error') {
                console.error(`Erro: ${result.message}`);
                console.error(`Detalhes: ${result.error}`);
            }
          });
        });
      }
    },
    //ALTERAÇÃO DE FILAS AGENDADA: O SERVIDOR APLICA AS PENDÊNCIAS VENCIDAS (O OPERADOR ESTÁ DESLOGADO)
    //E DEVOLVE AS FILAS ATUAIS. SE FALHAR, SEGUE O LOGIN COM AS FILAS DA PÁGINA - NUNCA IMPEDE O LOGIN.
    aplicarFilasAgendadas() {
      return axios.post('/filas-agendadas/aplicar', {}, { timeout: 15000 })
        .then(({ data }) => {
          if (data.alterado && Array.isArray(data.filas)) {
            console.info('[FilasAgendadas] Filas alteradas:', data.filas);
            user.atualizarFilas(data.filas);
            this.userQueues = user.getQueue().map(el => ({ queue: el, logged: false, paused: false }));
            this.setQueues(user.getQueue());
          }
          window.dispatchEvent(new CustomEvent('filas-agendadas:atualizar', { detail: data.alteracoes || [] }));
        })
        .catch(error => {
          console.error('[FilasAgendadas] Erro ao aplicar alterações agendadas:', error);
        });
    },
    mute() {
      //HABILITANDO O MUTE APENAS SE ESTIVER EM LIGAÇÃO
      if (this.getChannel()) {
        this.setMute();

        //COLOCANDO NO LOCALSTORAGE PARA PEGAR INFORMAÇÃO DO MUTE QUANDO ATUALIZAR A PÁGINA
        this.getMute == true
          ? localStorage.setItem("mute", "true")
          : localStorage.removeItem("mute");

        //CONTROLANDO SE É PARA COLOCAR O MUTE OU PARA TIRAR E ENVIANDO EMIT NECESSÁRIO
        var stateMute = this.getMute == true ? "on" : "off";
        connection.emit("MuteAudio", {
          channel: this.getChannel(),
          extension: user.getExtension(),
          state: stateMute,
        });
      }
    },
    async hangup() {
      connection.emit("hangup", {
        channel: this.getChannel(),
      });
      //Limpa o canal
      await this.setChannel("");

      //Limpa o ponta de lanca
      await clientData.mutations.delSpearheadData();
    },
    submitLogin(sub) {
      axios.post("/dialer/logs", { type: sub })
    },
    contacts() {
      if(!this.getContacts){
        if(user.getProfile() == 2){
          if(!this.getDeslog) this.setContacts();
        } else {
          this.setContacts();
        }
      }
    },
    operatorRealtime() {
      if(!this.getOperatorRealtime){
        if(user.getProfile() == 2){
          if(!this.getDeslog) this.setOperatorRealtime();
        } else {
          this.setOperatorRealtime();
        }
      }
    },
  },
  mounted() {
    this.fetchStoreQueues()
    this.checkTotalQUeues();
    this.totalMyQueue();

    // CAPTURANDO INFORMALÇÕES (SE ESTÁ EM LIGAÇÃO E SE ESTÁ LOGADO NA FILA)
    connection.emit("CoreShowChannels", {
      ramal: user.getExtension(),
    });

    // EVENTO PARA CAPTURAR DADOS DE LIGAÇÃO EM CURSO DO OPERADOR LOGADO
    connection.on(`CoreShowChannel-${user.getExtension()}`, async (data) => {
      //HABILITANDO CONTADOR E PASSANDO PRO CONTADOR QUANTO TEMPO ESTA EM LIGAÇÃO
      this.setCallTime(moment.duration(data.Duration).asSeconds());

      //BUSCANDO CLIENTE E PROTOCOLO DE ATENDIMENTO
      var self = this;

      this.fetchClients(data.ConnectedLineNum).then(async function () {
        //Recupera os dados tratado
        let phoneSplit = data.ConnectedLineName.split("||");
        let dataPhone = phoneSplit[1];

        if (self.allClients && self.allClients.length > 0) {
          self.chooseClient(self.allClients[0]);
          self.chooseClientCnpj(self.allClients[0]["cpf_cnpj"]);
          self.setShowSpearhead();
          // self.clearAllClients();
        } else {
          //SETANDO OS VALORES VAZIOS SE NÃO TIVER CLIENTE
          self.chooseClient({
            at_user_id: "",
            birthday: "",
            cep: "",
            city: "",
            complement: "",
            cpf: "",
            created_at: "",
            email: "",
            id: "",
            name: "",
            neighborhood: "",
            number: "",
            phone: dataPhone,
            phone_2: "",
            reference: "",
            rg: "",
            street: "",
            updated_at: "",
          });
          self.setShowSpearhead();
        }
      });
      this.fetchProtocol();
      //SETANDO O CANAL DA LIGAÇÃO ATUAL
      this.setChannel(data.Channel);

      if(data.Context === 'macro-arguments'){
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'queueIncoming');
      } else if(data.Context === 'macro-connect-line-externo'){
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'outgoing');
      } else if(data.Context === 'macro-transfer-blind'){
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'blindTransfer');
      }
      //HABILITANDO O MUTE NOVAMENTE CASO SEJA ATUALIZADO A PÁGINA
      localStorage.getItem("mute") && this.getChannel() && this.getMute == false
        ? this.setMute()
        : false;
    });

    // EVENT NECESSÁRIO PARA HABILITAR OS BOTÕES (LOGADO E PAUSA) QUANDO APESSOA ENTRA NA PAGINA
    connection.emit("QueueStatus", {
      ramal: user.getExtension(),
    });

    // HABILITANDO OS BOTÕES NOVAMENTE CASO ESTEJA LOGADO... EM PAUSA...
    connection.on(`QueueMember-${user.getExtension()}`, async(data) => {
      const queuename = data.Queue
      let find = this.userQueues.find(el => el.queue === queuename)
      if(find) find.logged = true
      if(this.userQueues.some(el => el.logged) && this.getDeslog) this.setDeslog();
      
      if (data.Paused == 1) {
          //INICIANDO CONTADOR DE PAUSA CASO ESTEJA EM PAUSA
          this.setPauseTime(data.LastPause);
          const time = this.getTime();
          const dataPause = {
            pauseId: data.PausedReason,
            tempo: `${time}`,
            userId: this.getId,
            preserveButton: this.userQueues.some(el => el.paused)
          };
          this.selectPause(dataPause);
        // }
        if(find) find.paused = true
      }
    });

    // VALIDANDO QUANDO USUÁRIO É INSERIDO NA FILA
    connection.on(`QueueMemberAdded-${user.getExtension()}`, (data) => {
      const queuename = data.Queue
      let find = this.userQueues.find(el => el.queue === queuename)
      if(find) find.logged = true
      
      if(this.getDeslog){
        this.setDeslog();
        this.startOrOut();
        this.submitLogin("LOGIN");
      }
    });

    // VALIDANDO QUANDO USUÁRIO É EXPULSO DA FILA
    connection.on(`QueueMemberRemoved-${user.getExtension()}`, (data) => {
      const queuename = data.Queue
      let find = this.userQueues.find(el => el.queue === queuename)
      if(find) find.logged = false 

      if(!this.userQueues.some(el => el.logged)){
        if (this.getPause == true) {
          this.userQueues.forEach(el => {
            if(el.paused){
              connection.emit('QueueUnPause', {
                extension: user.getExtension(),
                queue: el.queue
              });
            }
          })
        }
        if(!this.getDeslog) this.setDeslog();
        this.startOrOut();
        this.submitLogin("LOGOUT");
      }
    });

    // PEGANDO CANAL DO USUÁRIO EM LIGAÇÃO
    connection.on(`NewConnectedLine-${user.getExtension()}`, async (data) => {
      this.chooseClientPhone("");
      if(data.ChannelStateDesc !== 'Up') return;
      if(data.Context === 'macro-arguments'){
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'queueIncoming');
      } else if(data.Context === 'macro-connect-line-externo'){
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'outgoing');
      } else if(data.Context === 'macro-transfer-blind'){
        await clientData.mutations.setSpearheadData(data.ConnectedLineName, 'blindTransfer');
      }

      //Recupera os dados tratado
      let phoneSplit = data.ConnectedLineName.split("||");
      let dataPhone = phoneSplit[1];

      //INICIANDO O CONTADOR COM ZERO
      this.setCallTime(1);

      //BUSCANDO CLIENTE E PROTOCOLO DE ATENDIMENTO
      var self = this;
      this.fetchClients(dataPhone).then(function () {
        if (self.allClients && self.allClients.length > 0) {
          self.chooseClient(self.allClients[0]);
          self.chooseClientCnpj(self.allClients[0]["cpf_cnpj"]);
          self.setShowSpearhead();
          self.clearAllClients();
        } else {
          //SETANDO OS VALORES VAZIOS SE NÃO TIVER CLIENTE
          self.chooseClient({
            at_user_id: "",
            birthday: "",
            cep: "",
            city: "",
            complement: "",
            cpf: "",
            created_at: "",
            email: "",
            id: "",
            name: "",
            neighborhood: "",
            number: "",
            phone: dataPhone,
            phone_2: "",
            reference: "",
            rg: "",
            street: "",
            updated_at: "",
          });
          self.setShowSpearhead();
        }
      });
      this.fetchProtocol();

      //SETANDO CANAL NO STATE
      this.setChannel(data.Channel);
    });

    // DESABILITANDO BOTÃO DE MUTE QUANDO FINALIZADO A LIGAÇÃO
    connection.on(`Hangup-${user.getExtension()}`, async (data) => {
      this.hangupObj["uniqueid"] = data.Uniqueid;
      if (localStorage.getItem("mute")) {
        this.setMute();
        localStorage.removeItem("mute");
      }

      //CADASTRANDO A LIGAÇÃO REALIZADA DO CLIENTE
      var structClient = {
        at_user_id: this.getId,
        ticket: this.getProtocol.protocol,
        uniqueid: data.Linkedid,
        type: "telefonia",
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      };

      structClient.cpf_cnpj = this.oneClient ? this.oneClient.cpf_cnpj : null;
      this.saveClient(structClient);
      this.setCallTime("null");
      this.clearClient();
      this.clearAllClients();
      this.setChannel("");

      //LIMPANDO O CAMPO DE PRODUTO
      $(".select2-multi").val("-1").trigger("change");

      //Limpa o ponta de lanca
      await clientData.mutations.delSpearheadData();
    });

    connection.on(`QueueMemberPause-${user.getExtension()}`, (data) => {
      const queuename = data.Queue
      let find = this.userQueues.find(el => el.queue === queuename)
      const time = this.getTime();
      
      // Entrou em pausa
      if (data.Paused == 1) {
        this.setPauseTime(0);
        const dataPause = {
          pauseId: data.PausedReason,
          tempo: moment().format('YYYY-MM-DD HH:mm:ss'),
          queue: queuename,
          userId: parseInt(this.getId),
          preserveButton: this.userQueues.some(el => el.paused)
        };
        if(find) find.paused = true

        // this.sendPauseApi(dataPause);
        this.sendOperatorPauseApi(dataPause);
        this.selectPause(dataPause);
      }

      // Saiu da pausa
      if (data.Paused == 0 && find.paused) {
        var x = {
          pauseId: data.PausedReason,
          tempo: moment().format('YYYY-MM-DD HH:mm:ss'),
          queue: queuename,
          userId: parseInt(this.getId),
        };
  
        // this.sendUnpause(x);
        this.sendOperatorUnpause(x);
        
        if(find) find.paused = false
      }
      
      if(!this.userQueues.some(el => el.paused) && this.getPauseTime !== 'null'){
        this.setPauseTime("null");
        this.comeBack(`${time}`);
      }
    });
  },
};
</script>

<style scoped>
.blink-red {
		animation: blink-red 1s infinite;
	}

	@keyframes blink-red {
		0% { background-color: red; }
		50% { background-color: transparent; }
		100% { background-color: red; }
	}
.num {
  width: 25px;
  height: 25px;
  text-align: center;
  text-combine-upright: all;
  left: 4em;
  border-radius: 50%;
  line-height: 25px;
  color: white;
  background-color: red;
  top: 5.5em;
  position: absolute;
}

.barra-lateral-esquerdo {
  background-color: #cccccc;
  width: 100%;
  max-width: 99px;
  text-align: center;
  border-right: solid 1px #1c869a;
  min-height: 100%;
  height: calc(100vh - 4.5em);
  overflow: auto;
}

::-webkit-scrollbar {
  width: 0.18rem;
}

::-webkit-scrollbar-track {
  background: #f38630;
}

::-webkit-scrollbar-thumb {
  background: #1c869a;
}

.figure-image {
  margin: 0px;
  display: block;
}

.figure-image div {
  margin: 0px;
  padding: 9px 0 9px 0;
}

.figure-image figcaption {
  color: white;
}

.backGroundOrangeRed {
  background-color: orangered;
}

.backGroundOrange {
  background-color: #fea33b;
}

.bg-adv {
  background: #1c869a;
}

.backgroundGreen {
  background: #27ae60;
}

.count-msg {
  padding: 0px;
  color: white;
  font-size: 1.5em;
}

strong .count-msg {
  font-size: 1.5em;
}

.remove-padding {
  padding: 0 !important;
}
</style>



